<template>
  <div class="report el-tabs__content">
    <div class="card">
      <div class="card-body">
        <div class="media">
          <img :src="examInfo.picture_path ? examInfo.picture_path : '/static/img/user@3x.png'" class="avatar" />
          <div class="media-body">
            <h5>{{examInfo.user_name}}  <span class="badge rose align-middle">{{examInfo.cate_path}}</span></h5>
            <p><span class="gray">클래스</span> <strong>{{examInfo.class_name}}</strong></p>
          </div>
        </div>
      </div>
    </div>

   <R010100 @load-success="loadSuccess"></R010100>

  </div>
</template>

<script>
import R010100 from './R010100.vue'
export default {
  name: 'R010101',
  components: {R010100},
  data () {
    return {
      examInfo: {
        picture_path: '',
        user_name: '',
        cate_path: '',
        class_name: ''
      }
    }
  },
  methods: {
    loadSuccess (result) {
      this.examInfo = result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/R010101.vue